import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { productDatas } from "../Datas/ProductDatas/ProductDatas";
import { useSiteData } from "../Contexts/SiteContext";
import CheckoutLeft from "../Components/CheckoutComponents/CheckoutLeft";
import CheckoutRight from "../Components/CheckoutComponents/CheckoutRight";
import { nameToLinkConverter } from "../Datas/Functions/shareFunctions";
import { TitleSetup } from "../Datas/Functions/titleSetup";
const Checkout = (meta) => {
  const { register, handleSubmit } = useForm();
  TitleSetup({ ...meta });
  const [selectedProduct, setSelectedProduct] = useState({});
  const [quantity, setQuantity] = useState(1);
  const { pid } = useParams();
  useEffect(() => {
    const selected = productDatas.find(
      (prd) => nameToLinkConverter(prd.name) === pid
    );
    setSelectedProduct(selected);
    console.log(
      nameToLinkConverter("Thanos vai shobar shera hello"),
      selected,
      pid,
      productDatas
    );
  }, [pid]);

  const handleCheckout = (data) => {
    console.log(data);
  };

  return (
    <div className="md:container md:mx-auto w-full m-3 relative">
      <div className="grid grid-cols-12 md:gap-4 gap-2">
        <CheckoutLeft
          selectedProduct={selectedProduct}
          quantity={quantity}
          setQuantity={setQuantity}
        />
        {/* <CheckoutRight selected={[selectedProductPrice, setSelectedProductPrice]} /> */}
      </div>
    </div>
  );
};

export default Checkout;
